import { Stack, Text, Textarea } from '@mantine/core';

export default function FreetextScreen({ question, value = '', onChange, hideHeader = false }) {
  return (
    <Stack gap="lg">
      {!hideHeader && (
        <div>
          <Text fw={700} size="xl" style={{ color: 'var(--aviary-ink)', fontSize: 26, lineHeight: 1.3 }}>
            {question.ask}
          </Text>
          {question.sub && (
            <Text size="sm" mt={6} style={{ color: 'var(--aviary-muted)', lineHeight: 1.45 }}>
              {question.sub}
            </Text>
          )}
        </div>
      )}

      <Textarea
        minRows={5}
        autosize
        size="md"
        placeholder={question.placeholder || ''}
        value={value}
        onChange={(e) => onChange(e.currentTarget.value)}
      />
    </Stack>
  );
}
